<template>
  <div>
    <el-dialog
      title="编辑线上活动"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
    <el-form ref="form" :model="form" label-width="150px" size="mini" style="width:550px">
        <el-form-item label="分区" prop="name">
          <el-input v-if="form.zoneId != 0" v-model="form.zoneId" disabled></el-input>
          <el-input v-if="form.zoneId == 0" value="全区" disabled></el-input>
        </el-form-item>
        <el-form-item label="活动" prop="key">
          <el-input v-model="form.key" disabled></el-input>
        </el-form-item>
        <el-form-item label="活动开始时间">
          <el-date-picker v-model="form.startAt" type="date" disabled placeholder="选择日期" format="yyyy-MM-dd"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动结束时间">
          <el-date-picker v-model="form.endAt" type="datetime" :clearable="false" placeholder="选择时间"
            format="yyyy-MM-dd HH:mm" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="玩法开始时间">
          <el-date-picker v-model="form.playStartAt" type="date" disabled placeholder="选择日期" format="yyyy-MM-dd HH:mm"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="玩法结束时间">
          <el-date-picker v-model="form.playEndAt" type="datetime"  :clearable="false"  placeholder="选择日期" format="yyyy-MM-dd HH:mm"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="内容" v-if="form.context != 'null' && form.context != '{}'">
          <el-input   :value="formatCode(JSON.parse(form.context))" disabled type="textarea" :rows="7"  ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="settingActivityInOnline()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {},
    };
  },

  created() {
    this.form = this.value.info
  },
  props: {
    value: Object,
  },
  components: {
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async settingActivityInOnline() {
      try {
        // 弹确认框
        await this.$confirm(`确认编辑活动“${this.form.key}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/settingActivityInstanceInActive`,
            {
              activity:this.form
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      } catch (e) {}
    },

    ms2ymdhm(ts) {
    return util.ms2ymdhm(ts);
    },
    formatCode(obj){
        return JSON.stringify(obj, null, "    ")
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

